define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaParcel = void 0;
    class WaParcel extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ParcelType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ParcelTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lot", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LotError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Plan", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PlanError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lotplan", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LotplanError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Segpar", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SegparError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Tenure", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TenureError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QvasArea", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QvasAreaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QvasValuation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QvasValuationError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PropertyId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PropertyIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaParcel.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Wa = parent;
            this.WaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Wa = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaId = (0, EntityUtil_1.toInt)(entity.WaId);
            a.ParcelType = (0, EntityUtil_1.toInt)(entity.ParcelType);
            a.SrId = b.SrId;
            a.Lot = b.Lot;
            a.Plan = b.Plan;
            a.Lotplan = b.Lotplan;
            a.Segpar = (0, EntityUtil_1.toInt)(entity.Segpar);
            a.Tenure = b.Tenure;
            a.QvasArea = (0, EntityUtil_1.toFloat)(entity.QvasArea);
            a.QvasValuation = (0, EntityUtil_1.toFloat)(entity.QvasValuation);
            a.PropertyId = (0, EntityUtil_1.toInt)(entity.PropertyId);
            a.Shape = (0, EntityUtil_1.mergePolygon)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaParcel.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "ParcelType", "PARCEL_TYPE");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaId: this.WaId,
                ParcelType: this.ParcelType,
                SrId: this.SrId,
                Lot: this.Lot,
                Plan: this.Plan,
                Lotplan: this.Lotplan,
                Segpar: this.Segpar,
                Tenure: this.Tenure,
                QvasArea: this.QvasArea,
                QvasValuation: this.QvasValuation,
                PropertyId: this.PropertyId,
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.WaParcel = WaParcel;
    Object.defineProperty(WaParcel, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaParcel"
    });
    Object.defineProperty(WaParcel, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Water Agreement Parcel"
    });
    Object.defineProperty(WaParcel, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaId", "ParcelType", "SrId", "Lot", "Plan", "Lotplan", "Segpar", "Tenure", "QvasArea", "QvasValuation", "PropertyId", "Shape"]
    });
    Object.defineProperty(WaParcel, "WaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaParcel, "ParcelTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaParcel, "ParcelTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaParcel, "SrIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 30
    });
    Object.defineProperty(WaParcel, "SrIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaParcel, "LotLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(WaParcel, "LotReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaParcel, "PlanLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(WaParcel, "PlanReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaParcel, "LotplanLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 15
    });
    Object.defineProperty(WaParcel, "LotplanReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaParcel, "SegparReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaParcel, "TenureLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 40
    });
    Object.defineProperty(WaParcel, "TenureReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaParcel, "QvasAreaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaParcel, "QvasValuationReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaParcel, "PropertyIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "WaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "WaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "ParcelType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "ParcelTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "SrId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "SrIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "Lot", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "LotError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "Plan", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "PlanError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "Lotplan", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "LotplanError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "Segpar", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "SegparError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "Tenure", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "TenureError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "QvasArea", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "QvasAreaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "QvasValuation", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "QvasValuationError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "PropertyId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "PropertyIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaParcel.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaParcel.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaParcel.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaParcel.prototype, "merge", null);
});
